.error {
	max-inline-size: var(--width-content);
	padding: var(--spacing-6);
	margin-inline: auto;

	> pre {
		padding: var(--spacing-4);
		overflow-x: auto;
	}
}
